import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MpnSubscription, MpnSubscriptionResponse, MpnSubscriptionsQueryParams } from '@models/csp/mpn-subscription.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class MpnSubscriptionsService {
  private readonly url = `${environment.bffUrl}/csp/mpn-subscriptions`;
  constructor(private httpClient: HttpClient) {}

  getAll(params: MpnSubscriptionsQueryParams): Observable<MpnSubscription[]> {
    return this.httpClient.get<MpnSubscriptionResponse[]>(this.url, { params });
  }
}
